import React from 'react';

type PickupPointIconProps = {
    fillColor: string;
    strokeColor: string;
    bgFill: string;
    outerFill: string;
    showSuccessBadge?: boolean;
};

const AtPickupPointIconBase = ({
    fillColor,
    strokeColor,
    bgFill,
    outerFill,
    showSuccessBadge = false,
}: PickupPointIconProps) => (
    <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0.561523 29C0.561523 13.536 13.0976 1 28.5615 1C44.0255 1 56.5615 13.536 56.5615 29C56.5615 44.464 44.0255 57 28.5615 57C13.0976 57 0.561523 44.464 0.561523 29Z"
            fill={outerFill}
        />
        <circle cx="28.5615" cy="29" r="27" fill={bgFill} stroke={strokeColor} strokeWidth="2" />
        <g
            stroke={fillColor}
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
        >
            <path d="M18.4 19.5H38.7L41.3 26.5H15.8L18.4 19.5Z" />
            <path d="M23.5 19.5L22 26.5" />
            <path d="M28.55 19.5V26.5" />
            <path d="M33.6 19.5L35.1 26.5" />
            <path d="M16.8 26.5V38.6H20.2" />
            <path d="M40.3 26.5V38.6H26.9" />
            <path d="M30.9 38.6V30.9H35.6V38.6" />
            <path d="M23.55 38.9C23.55 38.9 27.25 34.4 27.25 32.55C27.25 30.5 25.6 28.85 23.55 28.85C21.5 28.85 19.85 30.5 19.85 32.55C19.85 34.4 23.55 38.9 23.55 38.9Z" />
        </g>
        <circle cx="23.55" cy="32.5" r="1.35" fill={fillColor} />
        {showSuccessBadge && (
            <>
                <circle cx="47.5615" cy="9" r="9" fill="#54C65F" />
                <path
                    d="M51.5218 5.3999L45.7618 11.0879L43.6018 8.9279L42.8818 9.7199L45.7618 12.5999L52.2418 6.1199L51.5218 5.3999Z"
                    fill="white"
                />
            </>
        )}
    </svg>
);

export const AtPickupPointDisabledBigIcon = () => (
    <AtPickupPointIconBase
        fillColor="#7E8CB2"
        strokeColor="#D8DEED"
        bgFill="#F8F9FE"
        outerFill="#F6F9FF"
    />
);

export const AtPickupPointOkBigIcon = () => (
    <AtPickupPointIconBase
        fillColor="#54C65F"
        strokeColor="#A7ECA5"
        bgFill="#F1FFF6"
        outerFill="#E8F9EA"
    />
);

export const AtPickupPointSuccessBigIcon = () => (
    <AtPickupPointIconBase
        fillColor="#54C65F"
        strokeColor="#A7ECA5"
        bgFill="#F1FFF6"
        outerFill="#93E191"
        showSuccessBadge
    />
);

export const AtPickupPointErrorBigIcon = () => (
    <AtPickupPointIconBase
        fillColor="#F9675D"
        strokeColor="#FFB4AE"
        bgFill="#FFF5F4"
        outerFill="#FFD9D6"
    />
);

export const AtPickupPointWarningBigIcon = () => (
    <AtPickupPointIconBase
        fillColor="#F5A623"
        strokeColor="#FFD88A"
        bgFill="#FFFBF0"
        outerFill="#FFE9B8"
    />
);

export const AtPickupPointOkWithWarningBigIcon = () => (
    <AtPickupPointIconBase
        fillColor="#54C65F"
        strokeColor="#A7ECA5"
        bgFill="#F1FFF6"
        outerFill="#93E191"
    />
);
